var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMexc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 41,
    viewBox: "0 0 262 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2638 28.6307L48.6971 5.07599C45.7362 0.17061 38.4442 0.126417 35.5716 5.29698L21.3416 29.7797C18.69 34.2874 21.9603 39.8998 27.3076 39.8998H55.9002C61.2476 39.944 65.2692 34.1106 62.2638 28.6307Z",
    fill: "#003087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6866 30.4867L41.847 29.0284C41.0515 27.6584 39.328 24.7417 39.328 24.7417L27.8379 4.76665C24.877 0.347383 17.8062 -0.0503573 14.8453 5.56212L1.4549 28.719C-1.32924 33.5802 1.98522 39.8998 7.99543 39.944H36.4113H48.52H55.7236C48.3874 39.9882 46.0454 36.1434 42.6866 30.4867Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6866 30.3983L41.847 28.94C41.0515 27.57 39.328 24.6533 39.328 24.6533L31.9037 11.5723L21.2532 29.7796C18.6016 34.2873 21.8719 39.8998 27.2192 39.8998H36.3671H48.4759H55.7236C48.3434 39.8556 46.0454 36.0992 42.6866 30.3983Z",
    fill: "url(#paint0_linear_1_166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.89 11.5026C240.879 9.64656 244.37 8.76269 249.452 8.76269H261.34V2.00122H247.287C243.928 2.00122 241.1 2.35478 238.89 3.06185C236.725 3.76894 234.824 4.87374 233.189 6.42049C231.466 8.09981 230.096 10.1768 229.124 12.6516C228.151 15.1706 227.665 17.9106 227.665 20.7831C227.665 23.5231 228.151 26.1746 229.124 28.6052C230.096 31.0358 231.466 33.157 233.189 34.8363C234.78 36.3831 236.68 37.4879 238.802 38.195C240.967 38.9021 243.84 39.2556 247.287 39.2556H261.34V32.5826H249.452C246.756 32.5826 244.9 32.4941 243.84 32.2732C242.735 32.0522 241.719 31.6987 240.879 31.1684C239.2 30.1077 237.918 28.7377 237.078 27.0142C236.283 25.3349 235.885 23.2137 235.885 20.7389C235.885 16.4964 236.902 13.3587 238.89 11.5026Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.435 39.344H168.58V32.8035H143.522V23.4788H165.398V17.2919H143.522V8.6301H168.58V2.04541H135.435V39.344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.844 2.04541L192.356 20.6947L176.844 39.344H186.876L199.117 24.5837V16.8499L186.876 2.04541H176.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.496 2.04541L202.254 16.8499V24.5837L214.496 39.344H224.528L208.972 20.6947L224.528 2.04541H214.496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.954 20.4296L88.0607 2.04541H80.3712V39.344H88.4584V14.4635L101.363 29.931H104.5L117.404 14.331V39.344H125.492V2.04541H117.891L102.954 20.4296Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_166",
    x1: 17.4521,
    y1: 21.5278,
    x2: 50.4669,
    y2: 33.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003087"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261.124,
    height: 40,
    fill: "white",
    transform: "translate(0.438171 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexc);
export default __webpack_public_path__ + "static/media/mexc.149bddd0bc1ef39dde0129bdb2701941.svg";
export { ForwardRef as ReactComponent };